import Seo from "../components/seo"
import { graphql } from "gatsby"
import * as React from "react"
import Title from "../components/title"
import Layout from "../components/layout"
import Spacer from "../components/spacer"
import ServiceList from "../components/serviceList"
import Process from "../components/proccess"

const ServicesPage = ({ data }) => {
  data = data.allDatoCmsServicesPage.nodes[0];
  return (
    <>
    <Layout>
      <Seo title="Services" />
      <Spacer />
      <Spacer className='m-hide' />
      <Title text='Services' />
      <Spacer className='m-hide' />
      <Spacer />
      <ServiceList services={data.ourServices} />
      <Spacer />
      <Spacer />
      <Process processes={data.ourProcesses} />
      <Spacer />
     
    </Layout>
    </>
  )
}

export default ServicesPage

export const query = graphql`
  query ServicesPage {
    allDatoCmsServicesPage {
      nodes {
        ourServices {
          title
          description
          image {
            gatsbyImageData(placeholder:NONE)
          }
        }
        ourProcesses {
          description
          name
        }
        nextPage{
          ...NextPage
        }
      }
    }
  }
`
